import "./PestControl.module.css";
import MainNavigation from "@/reusable_sections/Header";
import SystemIdentity from "./sections/SystemIdentity";
import TheRoadToClosing from "./sections/TheRoadToClosing";
import AgendaTuVisita from "./sections/AgendaTuVisita";
import Pestcontrolfaq from "./sections/Pestcontrolfaq";
import SystemFooter from "@/reusable_sections/Footer";
export default function PestControlPage() {
  return <div>
      <MainNavigation />
      <SystemIdentity />
      <TheRoadToClosing />
      <AgendaTuVisita />
      <Pestcontrolfaq />
      <SystemFooter />
    </div>;
}